<a
  (click)="$event.stopPropagation()"
  target="_blank"
  [routerLink]="patientHistoryRoute ? patientHistoryRoutePath : patientDetailsRoutePath"
  class="flex-center align-middle"
>
  <ng-content></ng-content>
  @if (showIcon) {
  <stx-patient-record-icon></stx-patient-record-icon>
  }
</a>
